import { useState, useEffect } from "react";
import '../css/characterSelector.css';
import '../css/external.css';
import statLabelMap from '../data/statLabelMap';
import { InputNumber } from "antd";



const stats = [
  "ElementalATK",
  "ATKPercent",
  "FlatATK",
  "ATKIncrease",
  "DEFPercent",
  "DEFIncrease",
  "HPPercent",
  "HPIncrease",
  "ElementalDMG",
  "CritRate",
  "CritDMG",
  "ATKSpd",
  "MoveSpdPercent",
  "Shield",
  "Healing",
  "BuffAmp",
  "DebuffAmp",
  "DEFPenetration",
  "TotalDMG",
  "Burst",
  "DamageReduction",
  "ElementalRES",
  "DEFReduce",
  "DMGTaken",
  "HealReduce",
  "ShieldReduce",
];

const specificATKPercentTypes = [
  "Basic",
  "Special",
  "Ultimate",
  "Passive",
];

const noPercent = ["ElementalATK", "FlatATK"]


const localStatLabelMap = {
  ...statLabelMap,
  // Overrides for better clarity
  ATKPercent: "Attack Percent (Sugarglass)",
  ATKIncrease: "Attack Increase (Team Buffs)",
  FlatATK: "Affection Attack (Mid-Battle Flat Buffs)",
  DEFPercent: "Defense Percent (Sugarglass)",
  DEFIncrease: "Defense Increase (Team Buffs)",
  HPPercent: "HP Percent (Sugarglass)",
  HPIncrease: "HP Increase (Team Buffs)",
  SpecificATKPercent: "Attack Damage Boost",
  DMGTaken: "Enemy Damage Taken",
  TotalDMG: "Total Damage"
};

const imageOverrides = {
  MoveSpdPercent: "MoveSpd",
  ElementalATK: "ATK",
  ATKPercent: "ATK",
  FlatATK: "ATK",
  ATKIncrease: "ATK",
  DEFIncrease: "DEF",
  HPIncrease: "HP",
  DEFPercent: "DEF",
  HPPercent: "HP",
};

const StatRow = ({
    statKey,
    label,
    value,
    onChange,
    showPercent = true
  }) => (
    <div className="statContainer">
      <div className="statWindow">
        <img
          src={`./img/Icons/Stats/${imageOverrides[statKey] || statKey}.webp`}
          className="statIcon"
          alt={statKey}
        />

        <span className="statText">
          {label}:
        </span>

        <InputNumber
            value={value}
            onChange={val => onChange(val ?? 0)}
            controls={false}
            className="statInputNumber"
            min={0}
            formatter={
                showPercent
                ? (val => (val !== null && val !== undefined ? `${val}%` : ""))
                : undefined
            }
            parser={
                showPercent
                ? (val => Number(String(val).replace('%', '')) || 0)
                : undefined
            }
        />
      </div>
    </div>
  );




const ExternalWrapper = ({ setExternalStats }) => {
  const [modalOpen, setModalOpen] = useState(false);

  const [values, setValues] = useState(() =>
    Object.fromEntries(stats.map(s => [s, 0]))
  );

  const [specificAtk, setSpecificAtk] = useState(() =>
    Object.fromEntries(specificATKPercentTypes.map(t => [t, 0]))
  );

  // Return stats to parent
  useEffect(() => {
    const statOutput = [];
    const targetedOutput = [];

    for (const [key, value] of Object.entries(values)) {
      if (value !== 0) {
        statOutput.push({ key, type: "External Stat", value: Number(value) });
      }
    }

    //Targeted stats are relegated to buffs
    for (const [type, value] of Object.entries(specificAtk)) {
      if (value !== 0) {
        targetedOutput.push({
          name: `External Stat`,
          hidden: true,
          stats: [{
            key: "SpecificATKPercent",
            type: "External Stat",    
            value: Number(value),
            target: { type }
          }]
        });
      }
    }
    const output = {stats: statOutput, buffs: targetedOutput};

    setExternalStats(output);
  }, [modalOpen]);



  return (
    <div className="externalWrapper">
      <h2 className="sectionTitle externalStatsTitle">External Stats</h2>

      <p> 🛈 Use to add custom stat values. Here you can add stats from team buffs, or stats from mode specific effects, like Abyss Raid Sugarglass Shards.  </p>

      <button onClick={() => setModalOpen(true)}>
        Edit External Stats
      </button>

      {modalOpen && (
        <div
          className="cookieModalOverlay"
          onClick={() => setModalOpen(false)}
        >
          <div
            className="cookieModalContent large"
            onClick={e => e.stopPropagation()}
          >
            <div className="statArea">
                <div className="modalTitle">External Stats</div>

                {/* NORMAL STATS */}
                <div className="statGrid">
                {stats.map(stat => (
                    <StatRow
                        key={stat}
                        statKey={stat}
                        label={localStatLabelMap[stat] || stat}
                        value={values[stat]}
                        showPercent={!noPercent.includes(stat)}
                        onChange={val =>
                        setValues(v => ({
                            ...v,
                            [stat]: val
                        }))
                        }
                    />
                    ))}
                </div>
                {/* SPECIFIC ATK */}
                <div className="statGrid">
                {specificATKPercentTypes.map(type => (
                    <StatRow
                        key={type}
                        statKey="SpecificATKPercent"
                        label={`${type} ${localStatLabelMap["SpecificATKPercent"]}`}
                        value={specificAtk[type]}
                        showPercent
                        onChange={val =>
                        setSpecificAtk(v => ({
                            ...v,
                            [type]: val
                        }))
                        }
                    />
                    ))}
                </div>
            </div>
            <button onClick={() => setModalOpen(false)}>
                Close
            </button>

          </div>
        </div>
      )}
    </div>
  );
};

export default ExternalWrapper;
